import $ from 'jquery';
import { closeModal } from '@/functions/function.js';
import EchangeApi from '@/api/_echange';

export default {
    name: 'articles',
    components: {},
    props: [],
    data () {
      return {
          fields: [
              { key: 'nom', label: 'Stock / armoire', thClass: 'stock-identity-heading' },
              { key: 'unite', label: 'Unité de soins' },
              { key: 'responsable', label: 'Responsable' },
              { key: 'actions', label: 'Actions', thClass: 'stock-actions-heading' },
          ],
          // Unités de soins : gérées dans Clinique → Paramètres → Équipe et Accès ; ici en lecture seule.
          unitesSoins: [],
          filter: "",
          loading: false,
          listLoading: true,
          listError: '',
          perPage: 30,
          currentPage: 1,
          stock: {},
          autorisation: false,
          personnalStocks: [],
      }
    },
    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        stocks() {
            return this.$store.getters['stocks']
        },

        users() {
            return this.$store.getters['users'] || []
        },

        stocksAffiches() {
            return (this.autorisation ? (this.stocks || []) : this.personnalStocks).map(item => ({
                ...item,
                unite: this.uniteDuStock(item.id),
                responsable: this.getUser(item.utilisateur_id),
            }));
        },

        stocksFiltres() {
            const normaliser = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
            const recherche = normaliser(this.filter).trim();
            if (!recherche) return this.stocksAffiches;
            return this.stocksAffiches.filter(item => normaliser([
                item.nom, item.description, item.unite, item.responsable,
            ].join(' ')).includes(recherche));
        },
     
    },
    watch: {
        filter() { this.currentPage = 1; },
    },
    mounted () {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

        this.$store.dispatch("getStocks").then(
            () => this.checkRole()
        ).catch(() => {
            this.listError = 'Impossible de charger les stocks. Rechargez la page pour réessayer.';
        }).finally(() => { this.listLoading = false; });
        this.$store.dispatch("getUsers");
        EchangeApi.hospitalServices().then(response => { this.unitesSoins = response.data || [] }).catch(() => { this.unitesSoins = [] });

    },
    methods: {

        uniteDuStock(stockId) {
            const unite = this.unitesSoins.find(item => Number(item.stock_id) === Number(stockId));
            return unite ? unite.name + (unite.is_active ? '' : ' (inactive)') : '';
        },

        getUser(id) {
            var user= "" 

            this.users.forEach(
                element => {
                    if(element.id == id) {
                        user = element.name
                    } 
                }
            );
            return user
        },

        setStock(data) {
            this.$set(this.stock, 'id', data.id)
            this.$set(this.stock, 'description', data.description)
            this.$set(this.stock, 'nom', data.nom)
            this.$set(this.stock, 'utilisateur', data.utilisateur_id)

        },

        async updateStock() {
            this.loading=true
            const data = {
                nom:  this.stock.nom,
                description:  this.stock.description,
                utilisateur_id:  this.stock.utilisateur,

            }   
    
            await this.$store.dispatch("editStock",{ 
                id:this.stock.id , 
                data: data 
            }).then(
                response => {
    
                    if (response) {
                        this.$refs.close_update.click()
                    } 
                }
            );
    
            this.loading=false
    
        },

        /**
         * Close Modal
         * @param {*} selector 
        */
        closeModal(selector) 
        {
            closeModal.closeModal(selector);
        },

        checkRole () {

            //Verification si utilisateur est admin ou pharmacienne (par nom de rôle : les ids varient selon l'environnement)
            this.autorisation = false;
            this.personnalStocks = [];
            const user = this.userCredentials && this.userCredentials.user;
            if (!user) return false;
            (user.roles || []).forEach(
                element => {
                    if(element.nom == 'ROLE_ADMINISTRATEUR' || element.nom == 'ROLE_PHARMACIEN' || element.nom == 'ROLE_RESPONSABLE_LOGISTIQUE') {
                        this.autorisation = true
                    }
                }
            );
    
            //S'il n'a paq autorisation afficher que ses stocks
            if (!this.autorisation) {
                (this.stocks || []).forEach(
                    element => {
                        
                        if(this.userCredentials.user.id == element.utilisateur_id ) {
                            this.personnalStocks.push(element)
                        } 
                    }
                );


            }

            return this.autorisation
        }
    }
  }
